// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_busStation,
  add_busStation,
  update_busStation,
  delete_busStation,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  busStations: [],
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name:"",
    vehicle:"",
    route_fair :"",
    lat :"",
    lon:"",
  },

};

// Async Thunks for API Calls
export const fetchbusStation = createAsyncThunk(
  "busStation/fetchbusStation",
  async (
    { vehicle_id,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_busStation(
      
        vehicle_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createbusStation = createAsyncThunk(
  "busStation/createbusStation",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_busStation(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatebusStation = createAsyncThunk(
  "busStation/updatebusStation",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_busStation(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletebusStation = createAsyncThunk(
  "busStation/deletebusStation",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_busStation({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const busStationSlice = createSlice({
  name: "busStations",
  initialState,
  reducers: {
    
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
      EditFormData(reduxState, action) {
        reduxState.formData = { ...action.payload };
      },
    resetFormData(state) {
      state.formData = {
        name:"",
        vehicle:state.formData.vehicle,
    route_fair :"",
    lat :"",
    lon:"",
      };
    },
    setbusStation(state, action) {
      state.busStations = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
  
  },
  extraReducers: (builder) => {
    builder
 
      // Fetch Classes
      .addCase(fetchbusStation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchbusStation.fulfilled, (state, action) => {
        state.loading = false;
        state.busStations = action.payload;
        console.log(action.payload)
       
      })
      .addCase(fetchbusStation.rejected, (state, action) => {
        state.loading = false;
        state.busStations = [];

        state.error = action.payload;
      })

      // Add Class
      .addCase(createbusStation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createbusStation.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createbusStation.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatebusStation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatebusStation.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatebusStation.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deletebusStation.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletebusStation.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletebusStation.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setbusStation,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,

} = busStationSlice.actions;
export default busStationSlice.reducer;
